import { render, staticRenderFns } from "./TableCompanyReports.vue?vue&type=template&id=908eb8ec"
import script from "./TableCompanyReports.vue?vue&type=script&lang=js"
export * from "./TableCompanyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports